import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SavePrepForTemplateChecklistParams } from "../types/SavePrepForTemplateChecklistParams";
import { SaveCallScriptFormResult } from "../types/SaveCallScriptFormResult";

export const useSavePrepForTemplateChecklistForm = (
	params: SavePrepForTemplateChecklistParams,
	onSuccess: (result: SaveCallScriptFormResult) => void,
	onError: (error: string) => void) => {

	let method = '';
	let requestParams: any;
	method = 'save-templateChecklistForm';
	requestParams = {
		RetailOrderID: params.formObject.RetailOrderID,
		RetailOrderNo: params.formObject.RetailOrderNo,
		AllCabinetryCheckBox: params.formObject.AllCabinetryCheckBox,
		AllExistingSpecialtyCheckBox: params.formObject.AllExistingSpecialtyCheckBox,
		AllItemsCheckBox: params.formObject.AllItemsCheckBox,
		AllSurfaceAreasCheckBox: params.formObject.ApronFrontCheckBox,
		ApronFrontCheckBox: params.formObject.ApronFrontCheckBox,
		CustomerSuppliedCheckBox: params.formObject.CustomerSuppliedCheckBox,
		CustomersResponsibilityCheckBox: params.formObject.CustomersResponsibilityCheckBox,
		DecisionMakerCheckBox: params.formObject.DecisionMakerCheckBox,
		IntroduceYourselfCheckBox: params.formObject.IntroduceYourselfCheckBox,
		LowesSurveyCheckBox: params.formObject.LowesSurveyCheckBox,
		MayISpeakToCheckBox: params.formObject.MayISpeakToCheckBox,
		Provide4HourWindowCheckBox: params.formObject.Provide4HourWindowCheckBox,
		ScheduleProjectCheckBox: params.formObject.ScheduleProjectCheckBox,
		WaterfallLegsCheckBox: params.formObject.WaterfallLegsCheckBox,
		Granite1120680Checkbox: params.formObject.Granite1120680Checkbox,
		Granite1120686Checkbox: params.formObject.Granite1120686Checkbox,
		Granite1120685Checkbox: params.formObject.Granite1120685Checkbox,
		Granite1120684Checkbox: params.formObject.Granite1120684Checkbox,
		Quartz1120670Checkbox: params.formObject.Quartz1120670Checkbox,
		Quartz1120676Checkbox: params.formObject.Quartz1120676Checkbox,
		Quartz1120675Checkbox: params.formObject.Quartz1120675Checkbox,
		Quartz1120674Checkbox: params.formObject.Quartz1120674Checkbox,
		GraniteGoldProtectionPlanCheckBox: params.formObject.GraniteGoldProtectionPlanCheckBox,
		Granite5YearCheckBox: params.formObject.Granite5YearCheckBox,
		Granite10YearCheckBox: params.formObject.Granite10YearCheckBox,
		FinishingTouchesCheckbox: params.formObject.FinishingTouchesCheckbox,
		SupportBracketsCheckBox: params.formObject.SupportBracketsCheckBox,
		SafetyCornersCheckBox: params.formObject.SafetyCornersCheckBox,
		ChipMinimizerCheckBox: params.formObject.ChipMinimizerCheckBox,
		SurveyCheckBox: params.formObject.SurveyCheckBox,
		ThankYouCheckBox: params.formObject.ThankYouCheckBox,
		NoteText: params.formObject.NoteText,
		DiscussOptionsCheckBox: params.formObject.DiscussOptionsCheckBox,
		PlumbingCheckBox: params.formObject.PlumbingCheckBox,
		PlumbingConnectionsCheckBox: params.formObject.PlumbingConnectionsCheckBox,
		PlumbingDisconnectCheckBox: params.formObject.PlumbingDisconnectCheckBox,
		PlumbingDisconnectInstallerCheckBox: params.formObject.PlumbingDisconnectInstallerCheckBox,
		PlumbingDisconnecCustomerCheckBox: params.formObject.PlumbingDisconnecCustomerCheckBox,
		Plumbing1120679CheckBox: params.formObject.Plumbing1120679CheckBox,
		Plumbing1120669CheckBox: params.formObject.Plumbing1120669CheckBox,
		PlumbingReconnectCheckBox: params.formObject.PlumbingReconnectCheckBox,
		PlumbingReconnectInstallerCheckBox: params.formObject.PlumbingReconnectInstallerCheckBox,
		PlumbingReconnectCustomerCheckBox: params.formObject.PlumbingReconnectCustomerCheckBox
	};

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/" + method, requestParams) as SaveCallScriptFormResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess) {
				onSuccess(result);
			}
			else
				onError(`Error when saving the pdf file"}: ` +
					result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}